import {generalService} from "../general/services";
import qs from 'qs';
import axios from 'axios';
import {store} from '../index';
import {addressConstants, carmelConstAPIMethods, carmelMethodsConstants, fopCardTypeRegex, generalConstants} from "../../constants";
import {formsConstants} from "../../constants/forms.constants";
import {carmelConstAPI} from "../../constants/carmel.constants";
import {paymentTypes} from "../../constants/fop.constants";
import {appHelp} from "../../helpers/app";
import {userConstLists} from "../../constants/user.constants";

export const carmelServices = {
    loadBasicInfo,
    serviceByAddr,
    getAirlineList,
    getPriceList,
    tripUpdate,
    addFop,
    deleteFop,
    updateCreditCard,
    validateHouseAccount,
    sendCustActivate,
    sendRateDriver,
    submitReferralCode,
    refreshToken
};

function serviceByAddr(addressType, currentLocation) {
    const state = store.getState();
    let Addr = state.trip[addressType];

    if (!Addr) {
        if (currentLocation && currentLocation.lat && currentLocation.lng)
            Addr = {
                latitude: currentLocation.lat,
                longitude: currentLocation.lng,
            };
    }
    // delete Addr.types;
    return generalService.requestSender(
        carmelConstAPIMethods.SERVICE_BY_ADDRESS,
        {
            'Credentials': generalService.getCarmelCredentials(),
            Addr: generalService.sanitizeCarmelAddress(Addr),
        }
    );
}

function getAirlineList(airlineCode) {
    const requestOptions = {
        data: {
            "calls": [
                {
                    "method": carmelConstAPIMethods.AIRLINE_LIST,
                    "params": {
                        "Credentials": generalService.getCarmelCredentials(),
                        "airportList": [
                            airlineCode
                        ],
                        'topAirlines': true
                    }
                }
            ]
        },
        headers: {
            "Content-Type": "application/json",
        },
        method: 'POST',
    };
    return axios(generalConstants.API_ENDPOINT, requestOptions).then(response => {
        return response
    })
}

function loadBasicInfo() {
    // The credentials object without any cust login details.
    // The API not working with those fields full.
    const sharedParams = {
        Credentials: generalService.getServerCredentials()

    };

    const airportListService = {
        method: carmelConstAPIMethods.AIRPORT_LIST,
        params: {
            airportListType: 'Service'
        }
    };
    const airportListAll = {
        method: carmelConstAPIMethods.AIRPORT_LIST,
        params: {
            airportListType: 'All'
        }
    };

    const countryList = {
        method: carmelMethodsConstants.COUNTRY_LIST
    };
    const stateList = {
        method: carmelMethodsConstants.STATE_LIST
    };
    const fopTypeList = {
        method: carmelMethodsConstants.FOP_TYPE_LIST
    };

    // Gathering all lists required for loading the app.
    return generalService.multipleCallsSender(
        sharedParams,
        [
            countryList,
            fopTypeList,
            airportListService,
            airportListAll,
            stateList
        ],
        'loadBasicInfo'
    );
}

function getPriceList() {
    const state = store.getState();
    const trip = state.trip;
    const Trip = {
        "asap": false,
        "cancelReason": "",
        "canceled": false,
        "completed": false,
        "custArrived": false,
        "custFirstTrip": false,
        "luggQty": 0,
        "passQty": 0,
        "prepaid": false,
        "puInstructions": false,
        "requestedDriverGender": "",
        "serviceType": "",
        "showExtraCharge": false,
        "showPrepay": false,
        "tripId": 0,
        "tripOptions": [],
        "tripStatus": "",
        "useCarCash": false,
        "verifyTerminal": false,
        ...trip,
    };

    Trip[addressConstants.PICK_UP_ADDRESS] = generalService.sanitizeCarmelAddress(Trip[addressConstants.PICK_UP_ADDRESS]);
    Trip[addressConstants.DROP_OFF_ADDRESS] = generalService.sanitizeCarmelAddress(Trip[addressConstants.DROP_OFF_ADDRESS]);

    return generalService.requestSender(
        carmelConstAPIMethods.PRICE_LIST,
        {
            Credentials: generalService.getCarmelCredentials(),
            Trip,
            fareOptions: true
        },
    );
}


function tripUpdate(eneble = null) {
    let state = store.getState(),
        {Cust} = state.user;
    const Credentials = ensureCustLocation(generalService.getCarmelCredentials(), state);
    const params = buildTripUpdateParams(state, Credentials, Cust);

    return generalService.requestSender(
        carmelConstAPIMethods.TRIP_UPDATE,
        params
    );
}

/**
 * The Carmel API on the mobile client always sends a `custLocation` block
 * inside `Credentials`. Cash trips on web fail with "Invalid form of
 * payment" when this is missing — the server appears to use the location
 * for fraud checks before approving non-card payments. Mirror the mobile
 * shape, falling back to the trip pickup coordinates when geolocation
 * isn't available in the browser.
 */
function ensureCustLocation(Credentials, state) {
    if (Credentials && Credentials.custLocation && typeof Credentials.custLocation.latitude === 'number') {
        return Credentials;
    }
    const pickup = state && state.trip && state.trip[addressConstants.PICK_UP_ADDRESS];
    const now = Date.now();
    const custLocation = {
        date: now,
        time: now,
        altitude: 0,
        longitude: pickup && typeof pickup.longitude === 'number' ? pickup.longitude : 0,
        latitude: pickup && typeof pickup.latitude === 'number' ? pickup.latitude : 0,
        speed: 0,
        bearing: 0,
        accuracy: 0,
        provider: '',
        locationDescription: ''
    };
    return {...Credentials, custLocation};
}

const TRIP_FARE_ALLOWED_KEYS = [
    'displayTextList', 'fare', 'congestionFee', 'fareTypeCd', 'taxExampt',
    'processingFeeOverride', 'taxOverride', 'fareOverride', 'commissionOverride',
    'expiresIn', 'total', 'fareId', 'fuelOverride', 'nysFundOverride',
    'discountOverride', 'priceQuotesIncludes', 'gratuityOverride', 'carCashAmt'
];

/**
 * Mobile sends a minimal fare object (~16 keys). Briz accumulates dozens of
 * zero-default fields from the price-list response and previous fop selections.
 * Strip to the mobile-allowed key set so the server validates cash bookings
 * the same way it does for the iOS client.
 */
function trimFareToMobileShape(fare) {
    if (!fare) return fare;
    const trimmed = {};
    TRIP_FARE_ALLOWED_KEYS.forEach(key => {
        if (fare[key] !== undefined) {
            trimmed[key] = fare[key];
        }
    });
    return trimmed;
}

/**
 * Mirrors the mobile Carmel client's `parseClientResponse`: only emit fields
 * the Carmel API expects on `Trip.cust`. UI-only flags like `loggedIn` and
 * server-injected placeholders such as `custId: 0` are stripped — empirically
 * those cause the server to reject cash bookings with "Invalid form of payment"
 * because, with no card to identify the customer, it falls back to validating
 * `cust` strictly.
 */
function sanitizeCustForCarmel(rawCust) {
    if (!rawCust) {
        return rawCust;
    }
    const sanitized = {};
    const fieldsToCopy = [
        'autoPostToCalendar',
        'debugUser',
        'guestUser',
        'emailAddr',
        'firstName',
        'lastName',
        'pictureUrl',
        'language',
        'updateGroup',
        'rewardProgramId',
        'rewardProgramMember',
        'userAction',
        'userActionRequired',
    ];
    fieldsToCopy.forEach(field => {
        if (rawCust[field] !== undefined) {
            sanitized[field] = rawCust[field];
        }
    });
    if (rawCust.phone) {
        sanitized.phone = {
            countryCode: rawCust.phone.countryCode,
            number: rawCust.phone.number,
        };
    }
    if (rawCust.phoneIce) {
        sanitized.phoneIce = {
            countryCode: rawCust.phoneIce.countryCode,
            number: rawCust.phoneIce.number,
        };
    }
    return sanitized;
}

export function buildTripUpdateParams(state, Credentials, customer) {
    let {trip} = state,
        Cust = customer;
    const selectedPrice = state.ui && state.ui.tripDetails
        ? state.ui.tripDetails.selectedPrice
        : null;
    const selectedCarCashAmount = selectedPrice && selectedPrice.carCashAvailable
        ? selectedPrice.carCashAvailable
        : 0;
    const fareWithCarCash = {
        ...(trip.fare ? {...trip.fare} : {}),
        carCashAmt: selectedPrice ? selectedCarCashAmount : trip.fare && trip.fare.carCashAmt
    };
    const carClassID = (selectedPrice && selectedPrice.carClassID) ||
        (trip.car && trip.car.carClassID);
    const Trip = {
        ...trip,
        fare: trimFareToMobileShape(fareWithCarCash),
        fop: trip.fop ? {...trip.fop} : {},
        // Mobile sends only carClassID; carClassDesc and other fields cause
        // server-side validation discrepancies for cash bookings.
        car: carClassID ? {carClassID} : {}
    };
    // Mobile request omits these UI-only flags from the Trip envelope.
    delete Trip.carPoolAllowed;
    Trip[addressConstants.PICK_UP_ADDRESS] = generalService.sanitizeCarmelAddress(Trip[addressConstants.PICK_UP_ADDRESS]);
    Trip[addressConstants.DROP_OFF_ADDRESS] = generalService.sanitizeCarmelAddress(Trip[addressConstants.DROP_OFF_ADDRESS]);
    const guestUserForm = state.forms[formsConstants.REGISTER_FORM];
    if (guestUserForm && Credentials.custAuthType === carmelConstAPI.authTypeGuest) {
        //creating cust to guest user
        Cust = {
            "lastName": guestUserForm[formsConstants.REGISTER_LNAME],
            "guestUser": true,
            "firstName": guestUserForm[formsConstants.REGISTER_FNAME],
            "phone": {
                "number": guestUserForm[formsConstants.REGISTER_PHONE],
                "countryCode": guestUserForm[formsConstants.REGISTER_COUNTRY].id
            },
            "emailAddr": guestUserForm[formsConstants.REGISTER_EMAIL],
        }
    }

    if (Trip.fop.fopCode === paymentTypes.HOUSE_ACCOUNT) {
        let form = state.forms[formsConstants.HOUSE_USER_FORM];
        Trip.account = {};
        Trip.account[formsConstants.HOUSE_USERNAME] = form[formsConstants.HOUSE_USERNAME];
        Trip.account[formsConstants.HOUSE_PASSWORD] = form[formsConstants.HOUSE_PASSWORD];
    }
    Trip.cust = sanitizeCustForCarmel(Cust);

    const finalTrip = {
        ...Trip,
        useCarCash: selectedPrice ? selectedCarCashAmount > 0 : !!Trip.fare.carCashAmt
    };
    return {Credentials, Trip: finalTrip};
}

function addFop() {
    const state = store.getState();
    const forms = state.forms;
    const {fopList} = state.user.lists.fop;
    const creditCardForm = forms[formsConstants.CREDIT_CARD];

    let fopCode = Object.keys(fopCardTypeRegex).filter(cardType => (
            creditCardForm.cardNumber.match(fopCardTypeRegex[cardType])
        )
    );

    let seq = 1;

    if (appHelp.validateArr(fopList) && fopList.length === 1) {
        let cardSeq = fopList[0].cardSeq;
        if (cardSeq) {
            seq = cardSeq % 2 + 1;
        }
    }
    let Fop = {};
    if (creditCardForm.prepayType === 'AI' || creditCardForm.prepayType === 'BASE')
        Fop = {
            ...creditCardForm,
            cardSeq: seq,
            fopCode: fopCode[0],
            autoCharge: true,
            onFile: false,
            saveNew: true,
            updateMode: 'Insert',
        };
    else
        Fop = {
            ...creditCardForm,
            cardSeq: seq,
            fopCode: fopCode[0],
            prepayType: "DFLT",
            autoCharge: false,
            saveNew: true,
            updateMode: 'Insert',
        };

    return generalService.requestSender(
        carmelConstAPIMethods.CUST_FOP_UPDATE,
        {
            'Credentials': generalService.getCarmelCredentials(),
            Fop
        }
    );
}

function deleteFop(cardSeq,fopId) {
    return generalService.requestSender(
        carmelConstAPIMethods.CUST_FOP_DELETE,
        {
            'Credentials': generalService.getCarmelCredentials(),
            cardSeq,
            fopId
        }
    );
}

function validateHouseAccount(accountId, accountPassword) {
    return generalService.requestSender(
        carmelConstAPIMethods.VALIDATE_ACCOUNT,
        {
            Credentials: generalService.getCarmelCredentials(),
            Account: {
                [formsConstants.HOUSE_USERNAME]: accountId,
                [formsConstants.HOUSE_PASSWORD]: accountPassword
            }
        }
    );
}

function updateCreditCard() {
    const state = store.getState();
    const forms = state.forms;

    const creditCardForm = forms[formsConstants.CREDIT_CARD];

    let fopCode = Object.keys(fopCardTypeRegex).filter(cardType => (
            creditCardForm.cardNumber.match(fopCardTypeRegex[cardType])
        )
    );
    let Fop = {};
    if (creditCardForm.prepayType === 'AI' || creditCardForm.prepayType === 'BASE')
        Fop = {
            ...creditCardForm,
            fopCode: fopCode && fopCode[0] ? fopCode[0] : creditCardForm[formsConstants.FOP_CODE],
            autoCharge: true,
            onFile: false,
            saveNew: true,
            updateMode: 'Update',
        };
    else
        Fop = {
            ...creditCardForm,
            fopCode: fopCode && fopCode[0] ? fopCode[0] : creditCardForm[formsConstants.FOP_CODE],
            prepayType: "DFLT",
            autoCharge: false,
            saveNew: true,
            updateMode: 'Update',
        };

    return generalService.requestSender(
        carmelConstAPIMethods.CUST_FOP_UPDATE,
        {
            'Credentials': generalService.getCarmelCredentials(),
            Fop
        }
    );

}

function normalizeActivationCountryCode(country) {
    if (!country) {
        return '';
    }

    const countryCode = country.id || country.phoneCode || country;
    return `${countryCode}`.replace('+', '');
}

function sendCustActivate(validationCode) {
    const state = store.getState();
    const custActivateForm = state.forms[formsConstants.CUST_ACTIVATE_FORM];

    const CustActivation = {
        requestCode: !validationCode,
    };

    if (validationCode) {
        CustActivation.userInput = validationCode;
    } else if (custActivateForm && custActivateForm[formsConstants.CUST_ACTIVATE_PHONE] && custActivateForm[formsConstants.CUST_ACTIVATE_COUNTRY]) {
        CustActivation.phone = {
            number: custActivateForm[formsConstants.CUST_ACTIVATE_PHONE],
            countryCode: normalizeActivationCountryCode(custActivateForm[formsConstants.CUST_ACTIVATE_COUNTRY])
        };
    }

    return generalService.requestSender(
        carmelConstAPIMethods.CUST_ACTIVATE,
        {
            'Credentials': generalService.getCarmelCredentials(),
            CustActivation
        }
    );
};


function sendRateDriver(ratingMessage, ratingId, tripId) {
    let params = {
        'Credentials': generalService.getCarmelCredentials(),
        'DriverRating': {
            ratingId: ratingId,
            ratingMessage: ratingMessage,
            ratingTitle: 'RATING TITLE',
            tripId: tripId
        }
    };

    return generalService.requestSender(
        carmelConstAPIMethods.DRIVER_RATING_REQUEST,
        params
    );
}

function submitReferralCode(sendCode, enterCode, referralCode) {
    const state = store.getState();
    const {referral} = state.user.lists;
    return generalService.requestSender(
        carmelConstAPIMethods.REFERRAL_CODE_SUBMIT,
        {
            'Credentials': generalService.getCarmelCredentials(),
            "AppReferral": {
                ...referral[userConstLists.REFERRAL_LIST],
                'enterCode': enterCode,
                "sendCode": sendCode,
                "referralCode": referralCode,
            },
        }
    );
};

function refreshToken() {
    const refreshToken = appHelp.getCookie('refresh_token');
    const body = {
        grant_type: "refresh_token",
        client_id: "b848b13e-243d-4269-8f55-3d6c3d383785",
        scope: "public;trip;user",
        server_token: generalConstants.CARMEL_API_KEY,
        refresh_token: refreshToken
    };

    return axios({
        method: 'post',
        url: generalConstants.TOKEN_REFRESH_ENDPOINT, //https://api.carmellimo.com/JobsWebServ/oauth2/v1/token
        data: qs.stringify({
            ...body
        }),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });

}